<mg-wrapper isConfigurator="true">
    <div *ngIf="(isInitialized$ | async) !== true" class="loading-indicator">
        <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>

    <mg-checkout-sticky-nav
        [modelName]="modelName$ | async"
        [titleVariant]="(route$ | async)?.index === 3 ? 'confirm' : 'default'"
        [class._is_initialized]="isInitialized$ | async"
    ></mg-checkout-sticky-nav>
    <mg-checkout-action-banner
        *ngIf="subsidyShowBanner"
        [content]="subsidyBannerContent"
        [color]="subsidyBannerColor"
    ></mg-checkout-action-banner>
    <mg-checkout-action-banner
        *ngIf="(route$ | async)?.index === 0 && !configurationId.startsWith('ext') && actionBannerContent"
        [content]="actionBannerContent"
        [color]="actionBannerColor"
    ></mg-checkout-action-banner>
    <mg-configurator [class._is_initialized]="isInitialized$ | async">
        <mg-checkout-accordion-wrapper>
            <!--active step-->
            <mg-checkout-accordion-content [isActive]="true">
                <router-outlet> </router-outlet>
            </mg-checkout-accordion-content>
        </mg-checkout-accordion-wrapper>
    </mg-configurator>
</mg-wrapper>
